import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { WalletManagementModel } from 'src/app/models/wallet/wallet-management.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WalletManagementService {

  constructor(private _httpClient: HttpClient) { }

  createWalletManagement(WalletManagementModel: WalletManagementModel): Observable<WalletManagementModel> {
    return this._httpClient.post<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.CreateAsync}`,
      WalletManagementModel
    );
  }

  deleteWalletManagement(walletManagementId: number): Observable<WalletManagementModel> {
    return this._httpClient.delete<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.DeleteAsync}/${walletManagementId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllClientsForSelect(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetAllClientsForSelectAsync}`);
  }

  getAllWalletManagementsWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetAllWalletManagementsWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstWalletManagementByKeys(branchId: number): Observable<WalletManagementModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetFirstWalletManagementByKeysAsync}`,
      { params: params }
    );
  }

  getLastWalletManagementByKeys(branchId: number): Observable<WalletManagementModel> {
    const params = new HttpParams().set('branchId', branchId);
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetLastWalletManagementByKeysAsync}`,
      { params: params }
    );
  }

  getNextWalletManagementByKeys(branchId: number, consecutive: number): Observable<WalletManagementModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetNextWalletManagementByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusWalletManagementByKeys(branchId: number, consecutive: number): Observable<WalletManagementModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetPreviusWalletManagementByKeysAsync}`,
      { params: params }
    );
  }

  getWalletManagementById(walletManagementId: number): Observable<WalletManagementModel> {
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetByIdAsync}/${walletManagementId}`)
  }

  getWalletManagementByConsecutive(branchId: number, consecutive: number): Observable<WalletManagementModel> {
    return this._httpClient.get<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.GetWalletManagementByConsecutiveAsync}/${branchId}/${consecutive}`);
  }

  setStateWalletManagement(walletManagementId: number): Observable<WalletManagementModel> {
    return this._httpClient.put<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.SetStateWalletManagement}/${walletManagementId}`,
      null
    );
  }

  updateWalletManagement(WalletManagementModel: WalletManagementModel): Observable<WalletManagementModel> {
    return this._httpClient.put<WalletManagementModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.walletManagement.UpdateAsync}`,
      WalletManagementModel
    );
  }
}
